import {
  GET_MESSAGES_FAIL,
  GET_MESSAGES_REQUEST,
  GET_MESSAGES_SUCCESS,
  ADD_ANSWER_FAIL,
  ADD_ANSWER_SUCCESS,
  ADD_ANSWER_REQUEST,
  DELETE_MESSAGE_FAIL,
  DELETE_MESSAGE_REQUEST,
  DELETE_MESSAGE_SUCCESS
} from "./actions";
import { IMessage } from "app/api/types";

interface IState {
  isLoading: boolean;
  page: number;
  count: number;
  limit: number;
  messageList: IMessage[];
}

const initialState: IState = {
  messageList: [],
  page: 1,
  count: 0,
  limit: 30,
  isLoading: false
};

const mastersReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case GET_MESSAGES_REQUEST:
    case ADD_ANSWER_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case DELETE_MESSAGE_REQUEST:
      return {
        ...state
      };

    case ADD_ANSWER_FAIL:
    case GET_MESSAGES_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_MESSAGE_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case GET_MESSAGES_SUCCESS:
      return {
        ...state,
        messageList: action.payload.messages,
        count: action.payload.count,
        limit: action.payload.limit,
        page: action.payload.page,
        isLoading: false
      };

    case ADD_ANSWER_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_MESSAGE_SUCCESS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};

export default mastersReducer;
